import { Component, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-no-medicines-note',
  imports: [CommonModule],
  templateUrl: './no-medicines-note.component.html',
  styleUrl: './no-medicines-note.component.css'
})
export class NoMedicinesNoteComponent implements AfterViewInit {
ngAfterViewInit() {
    const waitForCal = () => {
      const Cal = (window as any).Cal;
      if (Cal) {
        Cal('init', '30min', { origin: 'https://cal.com' });
        Cal.ns["30min"]("ui", {
          cssVarsPerTheme: {
            light: { "cal-brand": "#141F58" },
            dark: { "cal-brand": "#00CEBC" }
          },
          hideEventTypeDetails: false,
          layout: "month_view"
        });
      } else {
        setTimeout(waitForCal, 100);
      }
    };

    waitForCal();
  }
}